import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
  color: ${COLORS.secondarySemiDark};
  margin: 0 auto;
  max-width: 300px;
  margin-top: 100px;

  h2 {
    max-width: 300px;
    line-height: 1.3;
    font-weight: 400;
  }
`
